const selectEntity = (state, entity) => state.suppliesArchive[entity];

export const selectArchivedData = (state, entity) => selectEntity(state, entity).data;

export const selectArchivedLoading = (state, entity) => selectEntity(state, entity).loading;

export const selectArchivedError = (state, entity) => selectEntity(state, entity).error;
